export const ClientMapping = {
    dragdata: {
        checkboxfield: 'buildDefaultCheckBoxField',
        datepickerfield: 'buildDefaultDatePickerField',
        textfield: 'buildDefaultTextField',
        textareafield: 'buildDefaultTextAreaField',
        sectionfield: 'buildDefaultSectionField',
        selectfield: 'buildDefaultSelectField',
    },
    icons: {
        checkbox: 'check_box',
        datepicker: 'date_range',
        input: 'text_format',
        textarea: 'insert_comment',
        select: 'playlist_add',
    },
    inputtypes: {
        checkbox: 'Checkruta',
        datepicker: 'Datumfält',
        input: 'Textfält',
        textarea: 'Textruta',
        select: 'Dropdownlista',
    },
};
